import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CONTACT = {
    email: "akcatuncayy@gmail.com",
    phoneDisplay: "+31 6 24084278",
    phoneHref: "tel:+31624084278",
    whatsappUrl:
        "https://wa.me/31624084278?text=Hallo%20Freelance%20T,%20ik%20zoek%20hulp%20bij%20een%20crisissituatie.",
    region: "Landelijk inzetbaar",
};

export const IMAGES = {
    hero: "https://images.pexels.com/photos/3958461/pexels-photo-3958461.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    heroSecondary: "https://images.pexels.com/photos/4100421/pexels-photo-4100421.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    about: "https://images.pexels.com/photos/4100421/pexels-photo-4100421.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    hands: "https://images.pexels.com/photos/29060673/pexels-photo-29060673.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    walk: "https://images.pexels.com/photos/12887163/pexels-photo-12887163.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const submitContact = (data) => axios.post(`${API}/contact`, data);
export const submitBooking = (data) => axios.post(`${API}/booking`, data);

export const scrollToSection = (hash) => {
    const el = document.querySelector(hash);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -84, duration: 1.2 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};
